import React from "react";
import { Phone, Mail } from "react-feather";
import whicon from "../../assets/images/landingpage/wh-icon.png"

const FloatIcons = () => {
    return (
        <div
            className="position-fixed end-0 d-flex flex-column gap-2"
            style={{ transform: "translateY(-50%)", zIndex: 1050, top: '60%' }}
        >
            <a
                href="tel:+919108799731"
                className="btn btn-primary btn-sm "

                title="Call"
                style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '100px',
                    padding: '12px'
                }}
            >
                <Phone size={18} />
            </a>
            <a
                href="https://wa.me/919108799731"
                target="_blank"
                rel="noreferrer"
                className="btn btn-success btn-sm text-white "
                title="WhatsApp"
                style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '100px',
                    padding: '12px'
                }}
            >
                <img src={whicon}  alt="icon"  className="" style={{width:'18px'}}/>
            </a>
            <a
                href="mailto:sales@azsmenterprises.com"
                className="btn lanp-btn-primary btn-sm text-white"
                title="Email"
                style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '100px',
                    padding: '12px',
                    color:'#fff',
                }}
            >
                <Mail size={18} />
            </a>
            <a
                href="/book-demo"
                className="btn btn-warning d-flex align-items-center justify-content-center p-2 fw-bold lanp-bg-secondary text-white"
                style={{
                    writingMode: "vertical-rl",
                    textOrientation: "mixed",
                    height: "150px",
                    width: "50px",
                    borderTopLeftRadius: '20px',
                    borderBottomLeftRadius: '20px'

                }}
                title="Book A Demo"
            >
                Book A Demo
            </a>
        </div>
    );
};

export default FloatIcons;